module.exports = __webpack_public_path__ + "img/Image_7.bd1b7055.png";